import * as React from 'react';

var Medium = function (_a) {
    var _b = _a.idSuffix, idSuffix = _b === void 0 ? '' : _b;
    return (React.createElement("svg", { "aria-labelledby": "medium-icon-".concat(idSuffix), fill: "none", height: "40", role: "img", viewBox: "0 0 40 40", width: "40", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("title", { id: "medium-icon-".concat(idSuffix) }, "Invitae's Medium Page"),
        React.createElement("g", { fill: "#161616" },
            React.createElement("path", { d: "m21.6297 19.6244c0 3.9832-3.2264 7.2123-7.2061 7.2123-3.9798 0-7.20644-3.2291-7.20644-7.2123 0-3.9833 3.22644-7.2125 7.20644-7.2125s7.2061 3.2292 7.2061 7.2125z" }),
            React.createElement("path", { d: "m29.5351 19.6245c0 3.7494-1.6132 6.79-3.6032 6.79s-3.6032-3.0406-3.6032-6.79 1.613-6.79 3.603-6.79 3.6032 3.0397 3.6032 6.79" }),
            React.createElement("path", { d: "m32.7686 19.6244c0 3.3585-.5673 6.0828-1.2672 6.0828-.7 0-1.267-2.7235-1.267-6.0828 0-3.3592.5672-6.0828 1.267-6.0828.6997 0 1.2672 2.7233 1.2672 6.0828z" }))));
};

export { Medium as default };
//# sourceMappingURL=Medium.esm.js.map
